// dependencies
var $ = require('jquery')
var utils = require('Utilities/utils');



var button_toggle = function(params) {
	var self = this;

	// variables
	var $container;
	var current_value;
	var listen = false;
	var listener_cb;
	var options = {};

	// default options
	var default_args = {
		container : '.btn-toggle',
		buttons   : '.button',
		active    : 'button--active',
		inactive  : 'button--inactive',
		btn_data  : 'data-val',
		value     : null
	}



	// Private Functions
	//******************************************

	// remove any active states and set all to inactive
	var clear_state_classes = function() {
		$container.find('.' + options.active).removeClass(options.active).addClass(options.inactive);
	}


	// button has been clicked
	var btn_clicked = function(e) {
		e.preventDefault();
		e.stopPropagation();

		// clear states
		clear_state_classes();

		// update classes and retrieve value
		$btn = $(this);
		$btn.removeClass(options.inactive).addClass(options.active);
		current_value = $btn.attr(options.btn_data);

		// if listening then callback with updated value
		if (listen) {
			if (listener_cb) listener_cb(current_value);
		}
	}


	// add listener to button in group
	var add_listener = function(index) {
		$(this).off().on('click', btn_clicked);
	}


	// add listener to button in group
	var kill_listener = function(index) {
		$(this).off();
	}





	// Public Functions
	//******************************************
	self.init = function (params) {
		
		// assign to object and default items if needed
		options = utils.merge_options(default_args, params)
		//console.log(options);

		// assign initial value
		current_value = options.value;

		// get jquery object of container
		$container = $(options.container);

		//clear_state_classes();
		$container.find('[data-val="' + options.value + '"]').addClass(options.active);

		// assign listeners to each button in group
		$container.find(options.buttons).each( add_listener );
	}

	self.get = function() {
		// return current value of button
		return current_value;
	}

	self.addListener = function(cb) {
		// call back when value changes
		listen = true;
		listener_cb = cb;
	}

	self.removeListener = function() { 
		// stop reporting value change
		listen = false;
		listener_cb = null;
	}

	self.kill = function() {
		// kill listeners on button group buttons
		$container.find(options.buttons).each( kill_listener );

		// pass back final value
		return current_value;
	}

	self.init(params);
	return self;
}





// export module
module.exports = button_toggle;
